import React from "react";
import {Grid} from "@material-ui/core";
import {DateFormat} from "../../../../../helpers/DateFormat";
import {DirectionsWalk} from "@material-ui/icons";
import purge from "../Purge"
import Rest from "../../../../../helpers/Rest";

const ZONE_NAME = 0, DISTANCE = 1, APT_CODE = 2, APT_NAME = 3, PDU_CODE = 4, PDU_NAME = 5, TIMESTAMP = 6

function property(key, value){
    return (
        <React.Fragment key={key}>
            <Grid item xs={6}>
                <b>{key}</b>
            </Grid>
            <Grid item xs={6}>
                {value}
            </Grid>
        </React.Fragment>
    )
}

function eventType(event, classes){
    return (
        <React.Fragment key="Type">
            <Grid item xs={12} sm={6}>
                <b className={classes.event}><DirectionsWalk/> Zone Detection</b>
            </Grid>
            <Grid item xs={12} sm={6}>
                {(new DateFormat(event[TIMESTAMP])).datetime()}
            </Grid>
        </React.Fragment>
    )
}

function addDevice(row, deviceType, out){
    if (deviceType === "APT"){
        out.push(property("PDU Code", row[PDU_CODE]))
        out.push(property("PDU Name", row[PDU_NAME]))
    }
    else{
        out.push(property("APT Code", row[APT_CODE]))
        out.push(property("APT Name", row[APT_NAME]))
    }
}

export default {
    type: "zone",
    label: "Zone",
    timestampOffset: TIMESTAMP,
    getProperties: (row, deviceType, classes) => {
        const out = [
            eventType(row, classes),
            property("Zone", row[ZONE_NAME])
        ]
        addDevice(row, deviceType, out)
        if (Rest.isAdmin) {
            out.push(property("Distance", purge(row[DISTANCE], 'm')))
        }
        return out
    }
}
